"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductGift;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _icons = require("@sart/icons");
var _Text = _interopRequireDefault(require("./Text"));
var _Space = _interopRequireDefault(require("./Space"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getDescription(gift) {
  if (gift.units === "DATAKB") {
    gift.units = "MB";
    // gift.startingQuantity = gift.startingQuantity / 1024
  }
  return gift.startingQuantity + " " + gift.units;
}
function ProductGift(props) {
  var gift = props.gift,
    disabled = props.disabled,
    onPress = props.onPress;
  var content = (0, _content.useContent)();
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.container,
    onPress: onPress,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.placeholder
  }, /*#__PURE__*/_react["default"].createElement(_icons.GiftIcon, null)), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.body
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.header
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.title
  }, gift.balanceDisplayName), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.gift
  }, content.dashboard.gift))));
}
ProductGift.propTypes = {
  product: _propTypes["default"].object,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    height: 72,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.clear,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.exisOrange,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8
  },
  body: {
    flex: 1,
    padding: 12
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread({
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.feature
  }, _styles.typography.bold),
  gift: _objectSpread({
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.exisBlue
  }, _styles.typography.demi),
  description: _objectSpread({
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.focus
  }, _styles.typography.medium)
});